export const FEDERATION_KEY = 'federation';
export const CLAIMED_EMAILS_KEY = 'claimed_emails';
export const DATA_REGION_KEY = 'data_region';
export const ACCOUNT_FEDERATIONS_KEY = 'account_federations';
export const OIDC_CONFIGURATION_KEY = 'oidc_configuration';
export const SAML_CONFIGURATION_KEY = 'saml_configuration';
export const PASSWORD_POLICY_KEY = 'password_policy';
export const DOMAINS_KEY = 'domains';
export const ACCOUNTS_KEY = 'accounts';
export const IAM_ACCOUNTS_KEY = 'iam_accounts';
